<template>
    <div class="content1" v-if="code && isshow.expire !== 1">
        <div class="sub_title">
            <p @click="changed(0)" :class="tab == 0 ? 'active' : ''">提交答疑<i :class="tab == 0 ? 'active' : ''"></i></p>
            <p @click="changed(1)" :class="tab == 1 ? 'active' : ''">答疑记录<i :class="tab == 1 ? 'active' : ''"></i></p>
        </div>
        <div class="content_form" v-if="!tab">
            <el-form label-width="100px" class="demo-ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm">

                <el-form-item label="问题标题：" prop="title">
                    <el-input placeholder="请输入标题" v-model="ruleForm.title" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="问题类型：" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择问题类型">
                        <el-option :label="item.dictLabel" :value="item.dictValue" v-for="item in questionCategoryList"
                            :key="item.dictLabel"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属地区：" prop="region">
                    <el-select v-model="ruleForm.region" placeholder="请选择所属地区">
                        <el-option :label="item.provinceName" :value="item.provinceName"
                            v-for="item in provinceList
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "
                            :key="item.provinceName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属行业：" prop="industry">
                    <el-select v-model="ruleForm.industry" placeholder="请选择所属行业">
                        <el-option :label="item.dictLabel" :value="item.dictLabel"
                            v-for="item in industryList
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "
                            :key="item.dictLabel"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问题详情：" prop="content">
                    <el-input type="textarea" class="stretchNone" v-model="ruleForm.content"
                        placeholder="请填写问题详情"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="sub_btn" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <p class="sub_con">(提交成功后，24小时内将为您解答)</p>
                </el-form-item>
            </el-form>
        </div>
        <div class="content_jl" v-else>
            <div class="sub_title_2">
                <p :class="tab2 == item.categoryId ? 'active2' : ''" @click="changeTypefun(item.categoryId)"
                    v-for="item in categoryList" :key="item.categoryId">{{ item.categoryName + '(' + item.number + ')'
                    }}<i></i>
                </p>
                <!-- <p :class="tab2==1?'active2':''" @click="changeTypefun(1)">税务问题(0)<i></i></p>
              <p :class="tab2==2?'active2':''" @click="changeTypefun(2)">财税综合问题(5)<i></i></p> -->
            </div>
            <div class="slelet_check">
                <p :class="tab3 == 0 ? 'active3' : ''" @click="changeTypefun2(0)">全部</p>
                <p :class="tab3 == 1 ? 'active3' : ''" @click="changeTypefun2(1)">未解决</p>
                <p :class="tab3 == 2 ? 'active3' : ''" @click="changeTypefun2(2)">已解决</p>
            </div>
            <div class="jl_content" v-if="answerList.length > 0">
                <div class="jl_item" v-for="item in answerList" :key="item.questionid">
                    <div class="jl_title">
                        <img src="../../../assets/img/pa14.jpg" alt="">
                        <h3>问题标题</h3>
                        <p :class="item.info == 1 ? 'sq btn' : ' zk btn'" @click="cahngezk(item)">{{ item.info == 0 ? '展开' :
                            '收起' }}</p>
                    </div>
                    <h4 class="sub_title3">{{ item.title }}</h4>
                    <div class="tw">
                        <div :class="item.info == 1 ? 'jl_item_con1' : 'jl_item_con'">{{ item.content }}</div>
                        <p class="jl_item_l">
                            提问时间：{{ item.questionTime }}
                        </p>
                    </div>
                    <div v-if="item.answer && item.info == 1" class="jl_title">
                        <img src="../../../assets/img/pa14.jpg" alt="">
                        <h3>专家解答</h3>
                    </div>
                    <h4 v-if="item.answer && item.info == 1" class="sub_title3">尊敬的中税网会员：您好！<br /> 对您的提问回复如下：</h4>
                    <div v-if="item.answer && item.info == 1" class="tw">
                        <!-- <div :class="item.info == 1 ? 'jl_item_con' : ''">{{ item.answer }}</div> -->
                        <div class="jl_item_con1"
                            style="font-family: arial; font-size: 18px;margin: 0;padding: 0;font-weight: 600;"
                            v-if="item.answer">
                            专家分析:
                        </div>
                        <div class="jl_item_con1" v-html="item.answer"></div>
                        <div class="jl_item_con1" v-if="item.policy"
                            style="font-family: arial; font-size: 18px;margin: 0;padding: 0;font-weight: 600;">
                            政策依据:
                        </div>
                        <div class="jl_item_con1" v-html="item.policy"></div>
                        <div class="jl_item_con1" style="font-family: arial; font-size: 18px;margin: 0;padding: 0;">
                            欢迎您再次提问<br>
                            中税网财税专家<br>
                            ------------------------------------------------------------------
                            <br>
                            中税网专家咨询部<br>
                            您贴心的财税专家-----一站式会员服务
                        </div>
                        <p class="jl_item_l">
                            回答时间：{{ item.answerTime }}
                        </p>
                    </div>
                    <div class="line"></div>
                </div>
                <div v-if="pageNum < totalPages && answerList.length > 0" class="chakan" @click="getmore()">查看更多</div>
                <div v-if="pageNum >= totalPages && answerList.length > 0" class="mygd">没有更多了！</div>
            </div>
            <div v-else>
                <el-empty :image="require('../../../assets/img/dy111.png')" description='暂无数据~'></el-empty>

            </div>
        </div>
    </div>
    <div class="content1" v-else>
        <div class="zwt">
            <br><br><br><br><br><br><br><br>
            <div class="zsw_img">
                <img src="../../../assets/statstics/监控未获取数据@2x.png" alt="">
            </div>
            <div class="zwt_wz">您暂时无法使用，请联系您的专属学习顾问确认已加入会员（金卡及以上会员）</div>
        </div>
    </div>
</template>

<script>
import { getSelectOption, submitQa, getnumber, getlist } from '@/api/index.js'

export default {
    props: ['code'],
    data() {
        return {
            isshow: "",
            totalPages: "",//总页数
            zk: true,//控制展开还是收起
            tab3: 0,//控制全部
            tab2: 1,//控制问题类型tab  等同于type
            tab: 0, //0提交答疑1答疑记录
            categoryList: [],//记录头数据
            answerList: [],//记录列表
            countPage: 0,//记录总条数
            pageNum: 1,//当前页
            pageSize: 10,//分页条数
            type: 1,//记录头部
            status: null,//全部 0未解答1解答
            provinceList: [],
            industryList: [],
            questionCategoryList: [],
            imgtcc: require('../../../assets/img/tcc.png'),
            ruleForm: {
                title: '',
                type: '',//类别
                region: '',
                industry: '',
                content: '',
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                    { max: 100, message: '长度在100个字符以内', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择问题类型', trigger: 'change' }
                ],
                region: [
                    { required: true, message: '请选择所属地区', trigger: 'change' }
                ],
                industry: [
                    { required: true, message: '请选择所属行业', trigger: 'change' }
                ],
                content: [
                    { required: true, message: '请填写问题详情', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        scrollTo(0, 0);
        this.dept = localStorage.getItem('dept');
        this.token = localStorage.getItem('token');
        this.isshow = JSON.parse(window.localStorage.getItem('gqxx'))
        this.getSelectOptionInit()
        this.getnumberPaInit()
        this.getList()
    },
    methods: {
        getmore() {
            if (this.pageNum < this.totalPages) {
                this.pageNum = this.pageNum + 1;
                this.getList();
            } else {
                this.$message.warning("没有更多了！");
            }
        },
        getList() {
            const params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                type: this.type,
                status: this.status,
            }
            getlist(params, {
                Authorization: this.token,
                DeptId: this.dept,
            }).then(res => {
                if (res && res.code === 200) {
                    //控制展开折叠字段 Info
                    let list = res.data.list.map(item => {
                        item.info = 0
                        return item
                    })

                    this.answerList = [...this.answerList, ...list]
                    this.countNum = res.data.countNum
                    this.countPage = res.data.totalRecords
                    this.totalPages = res.data.totalPages
                }
            })
        },
        getnumberPaInit() {
            getnumber({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res && res.code === 200) {
                    //  console.log(res.data, 'res.data111111111111111');
                    this.categoryList = res.data
                }
            })
        },
        getSelectOptionInit() {
            getSelectOption({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    //  console.log('res---', res);
                    this.provinceList = res.data.provinceList
                    this.questionCategoryList = res.data.questionCategoryList
                    this.industryList = res.data.industryList
                }
            })
        },
        cahngezk(item) {
            item.info = item.info == 0 ? 1 : 0
            // this.zk = this.zk?false:true
        },
        changeTypefun2(val) {
            this.tab3 = val
            if (val == 0) { this.status = null }
            else { this.status = val - 1 }
            this.answerList = []
            this.pageNum = 1
            this.getList()
        },
        changeTypefun(val) {
            //  console.log(1111);
            this.tab2 = val
            this.type = val
            this.answerList = []
            this.pageNum = 1
            this.getList()
        },
        changed(val) {
            this.tab = val
        },
        submitForm(formName) { //提交问题
            let type = this.ruleForm.type
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    submitQa(this.ruleForm, {
                        Authorization: this.token,
                        DeptId: this.dept
                    }).then(res => {
                        if (res.code == 200) {//您的问题已提交成功，24小时内专家将为您解答！
                            this.$alert(`<div style="text-align: center;"><img style="width:70px;" src="${this.imgtcc}"/><p>您的问题已提交成功，24小时内专家将为您解答！</p></div>`
                                , '', {
                                dangerouslyUseHTMLString: true, center: true, confirmButtonText: "确定",
                                callback: action => {
                                    //  console.log(type, 'type11111111111111111111');
                                    this.$refs['ruleForm'].resetFields();
                                    this.getnumberPaInit()
                                    this.changed(1) //切换答疑记录
                                    this.changeTypefun(type)//问题类型切换
                                }
                            });
                        }
                    })
                } else {
                    //  console.log('error submit!!');
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="less" scoped>
.zwt {
    width: 700px;
    height: 600px;
    text-align: center;
    margin: 0 auto;

    .zsw_img {
        width: 260px;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;

    }

    .zwt_wz {
        width: 700px;
        margin-top: 70px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
    }
}

//文本域禁止缩放
.jl_content {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;
}

/deep/.stretchNone {
    .el-textarea__inner {
        resize: none;
    }
}

.content1 {
    min-height: 600px;
    padding: 15px;
    width: 100%;
}

.content_form {
    display: flex;
    justify-content: center;
    padding-top: 20px;
}

.sub_title {
    width: 100%;
    display: flex;
    font-size: 18px;
    margin-left: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    cursor: pointer;
}

.sub_title .active {
    color: #3E63EE;
}

.sub_title p {
    margin-left: 20px;
    position: relative;
}

.sub_title i.active {
    position: absolute;
    top: 28px;
    left: 30px;
    content: 0px;
    width: 16px;
    border-top: 4px solid #3E63EE;
}

.el-form-item {
    width: 585px;
}

/deep/.el-form-item .el-input__inner {
    width: 450px;
}

/deep/.el-form-item .el-textarea__inner {
    width: 450px;
}

// /deep/.el-form-item .el-form-item__error {
//     top: 27%;
//     left: 356px;
//     color: #F56C6C;
// }

.el-form-item .sub_btn {
    position: absolute;
    left: 55%;
    width: 100px;
    transform: translateX(-100%);
    background: rgba(62, 99, 238, 1);
}


.el-form-item .sub_con {
    position: absolute;
    top: 20px;
    left: 95px;
}

.content_jl {
    padding: 0 40px;
    box-sizing: border-box;
}

.content_jl .active2 {
    position: relative;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    cursor: pointer;
    color: #3E63EE;
}

.content_jl .active2 i {
    position: absolute;
    top: 28px;
    left: 30px;
    content: 0px;
    width: 16px;
    border-top: 4px solid #3E63EE;
}

.content_jl .sub_title_2 {
    border-top: 2px solid #f2f2f2;
    height: 98px;
    width: 100%;
    font-size: 18px;
    color: #8d97a1;
    display: flex;
    cursor: pointer;
    align-items: center;
}

.content_jl .slelet_check {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    color: #8d97a1;
}

.content_jl .active3 {
    position: relative;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    cursor: pointer;
    color: #333;
}

.content_jl p {
    margin-left: 35px;
}

.content_jl p:first-child {
    margin-left: 0px;
}

.content_jl .jl_item {
    margin-top: 30px;
    margin-bottom: 50px;
    padding: 6px 15px;
    box-sizing: border-box;
    width: 100%;
    /* height: 180px; */
    //   background: #fafafa;
    border-radius: 5px;
}

.content_jl .jl_item .line {
    position: relative;
    bottom: -31px;
    content: 0;
    border-top: 2px solid #ededed;
}

.content_jl .jl_item .tw {
    background: #fafafa;
}

.content_jl .jl_item .jl_title {
    height: 64px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
}

.content_jl .jl_item .jl_title img {
    width: 20px;
    height: 20px;
    margin-right: 16px;
}

.content_jl .jl_item .jl_title h3 {
    font-size: 18px;
}

.content_jl .jl_item .jl_title .sub_title3 {
    margin: 0;
}

.content_jl .jl_item .jl_title .btn {
    position: absolute;
    padding-right: 20px;
    right: 16px;
    color: #848f9a;
    cursor: pointer;
}

.content_jl .jl_item .tw {
    padding: 10px;
    margin: 5px;
}

.content_jl .jl_item .jl_title .zk {
    background: url(../../../assets/img/pa13.jpg) no-repeat;
    background-size: 16px 10px;
    background-position: 100% 50%;
}

.content_jl .jl_item .jl_title .sq {
    background: url(../../../assets/img/pa16.jpg) no-repeat;
    background-size: 16px 10px;
    background-position: 100% 50%;
}

.content_jl .jl_item .jl_item_con {
    width: 1000px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;

}

.content_jl .jl_item .jl_item_con1 {
    width: 1000px;
    height: auto;
    word-wrap: break-word;
    word-break: break-all;
}

.content_jl .jl_item .jl_item_l {
    color: #848f9a;
    text-align: right;
}

.content_jl .chakan {
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    background: orange;
    color: #fff;
    border-radius: 20px;
    margin: 0 auto;
    left: 50%;

    cursor: pointer;
}

.content_jl .mygd {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #333;
}

.el-empty__image>img {
    border: 2px dashed #ccc !important;
}

/deep/ .el-input .el-input__count .el-input__count-inner {
    padding: 0;
    margin: 0 -17px;
}
</style>